import { Component, OnInit, TemplateRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { COMPLIANCE, POLICIES_AND_PROCEDURES, PRIVACY_POLICY, TERMS_OF_USE } from 'src/app/core/constants/links';
import { FooterService } from 'src/app/core/services/footer.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'th-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  currentYear: number;
  releaseNumber: string;

  termsOfUseLink: string = TERMS_OF_USE;
  privacyPolicyLink: string = PRIVACY_POLICY;
  policiesAndProceduresLink: string = POLICIES_AND_PROCEDURES;
  complianceLink: string = COMPLIANCE;

  constructor(
    private footerService: FooterService,
    public authService: AuthService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.currentYear = new Date().getFullYear();

    this.getReleaseNumber();
  }

  getReleaseNumber() {
    this.footerService.getReleaseNumber().subscribe((releaseNumber) => {
      this.releaseNumber = releaseNumber;
    });
  }

  openFeedbackModal(templateRef: TemplateRef<unknown>) {
    this.modalService.open(templateRef, { size: 'lg' });
  }
}
